const routes = {
    ip: {
        get: '/click-server-ips/index-data',
        create: '/click-server-ips/new',
        show: '/click-server-ips/:id',
        update: '/click-server-ips/:id/update',
        delete: '/click-server-ips/:id/delete',
    },
    group: {
        get: '/click-server-ips/groups/index-data',
        show: '/click-server-ips/groups/:id',
        edit: '/click-server-ips/groups/:id/edit',
        delete: '/click-server-ips/groups/:id/delete',
    },
};

export default routes;
